import { query } from '../../network/fetch'
import { pluck } from '../../utilities'
import {
    getStatusReport,
    getTokenReport,
    getBeaconReport,
    getCancellationReport,
    getClassReport,
    getLastAttendanceReport,
    getFacilityReport,
    getStudentReport,
    getEventReport,
    getSetupReport
} from '../../network/queries/report'
import {
    REPORT_CLEAR,
    REPORT_LIST,
    REPORT_ARRAY_LIST,
    STUDENT_COURSE_REPORT_LIST,
    STUDENT_EVENT_REPORT_LIST

} from '../types'

const state = {
    items: [],
    total: 0,

    //for Student Report
    studentCourses: [],
    studentEvents:[]

}

const actions = {

    getStatusReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        return new Promise((resolve) => {
            query({
                query: getStatusReport,
                variables: pluck(filters, [
                    'start_date',
                    'end_date',
                    'teams',
                    'courses',
                    'events',
                    'mode',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.statusReport)
                resolve(data)
            })
        })
    },

    getTokenReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        return new Promise((resolve) => {
            query({
                query: getTokenReport,
                variables: pluck(filters, [
                    'teams',
                    'courses',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.tokenReport)
                resolve(data)
            })
        })
    },

    getBeaconReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        return new Promise((resolve) => {
            query({
                query: getBeaconReport,
                variables: pluck(filters, [
                    'factory_id',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.beaconReport)
                resolve(data)
            })
        })
    },


    getCourseReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        if (!filters.uuid) return
        return new Promise((resolve) => {
            query({
                query: getClassReport,
                variables: pluck(filters, [
                    'uuid',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.courseReport)
                resolve(data)
            })
        })
    },

    getLastAttendanceReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        return new Promise((resolve) => {
            query({
                query: getLastAttendanceReport,
                variables: pluck(filters, [
                    'teams',
                    'course_id',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.lastAttendanceReport)
                resolve(data)
            })
        })
    },

    getStudentReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        if (!filters.uuid) return
        return new Promise((resolve) => {
            query({
                query: getStudentReport,
                variables: pluck(filters, [
                    'uuid'
                ])
            }).then( ({ data }) => {
                commit(STUDENT_COURSE_REPORT_LIST, data.student)
                commit(STUDENT_EVENT_REPORT_LIST, data.student)
                resolve(data)
            })
        })
    },

    getEventReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        if (!filters.uuid) return
        return new Promise((resolve) => {
            query({
                query: getEventReport,
                variables: pluck(filters, [
                    'uuid',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.eventReport)
                resolve(data)
            })
        })
    },

    getSetupReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        return new Promise((resolve) => {
            query({
                query: getSetupReport,
                variables: pluck(filters, [
                    'mode',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.setupReport)
                resolve(data)
            })
        })
    },

    getCancellationReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        return new Promise((resolve) => {
            query({
                query: getCancellationReport,
                variables: pluck(filters, [
                    'start_date',
                    'end_date',
                    'sort_by',
                    'sort_dir',
                    'page'
                ])
            }).then( ({ data }) => {
                commit(REPORT_LIST, data.cancellationReport)
                resolve(data)
            })
        })
    },

    getFacilityReport({ commit }, filters) {
        commit(REPORT_CLEAR)
        return new Promise((resolve) => {
            query({
                query: getFacilityReport,
                variables: pluck(filters, [
                    'date',
                    'location_id'
                ])
            }).then( ({ data }) => {
                commit(REPORT_ARRAY_LIST, data.facilityReport)
                resolve(data)
            })
        })
    },
}

const mutations = {
    [REPORT_CLEAR] (state) {
        state.items = null
        state.total = 0
        state.studentCourses = null
        state.studentEvents = null
    },
    [REPORT_ARRAY_LIST](state, data) {
        state.items = data
        state.total = data.length
    },
    [REPORT_LIST](state, { data, total }) {
        state.items = data.map( (item) => Object.assign({}, item) )
        state.total = total
    },
    [STUDENT_COURSE_REPORT_LIST](state, { course_report }) {
        state.studentCourses =  course_report
    },
    [STUDENT_EVENT_REPORT_LIST](state, { event_report }) {
        state.studentEvents =  event_report
    },
}

export default {
    state,
    actions,
    mutations
}
